import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useTheme } from "@mui/material/styles";

const RecordedContactActionCell = ({ id, row, onEditContact }) => {
  const apiRef = useGridApiContext(); 
  const theme = useTheme();


  const handleEdit = () => {
    onEditContact(row);
  };

  const handleOpenDetailPanel = () => {
    apiRef.current.toggleDetailPanel(id);
  };

  return (
    <>
      <Tooltip title="Edit Contact">
        <IconButton onClick={handleEdit} size="small" sx={{ mx: 0.5, color: theme.palette.text.primary }}>
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="View Playlists">
        <IconButton
          onClick={handleOpenDetailPanel}
          size="small"
          sx={{ mx: 0.5, color: theme.palette.text.primary }}
        >
          <HeadphonesIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default RecordedContactActionCell;
